export default __webpack_public_path__ + "static/media/element_99.40c33cbf.webp";